[{
    "id": "1",
    "classcode": "65132",
    "statcode": "65132",
    "siccode": "6513",
    "naicscode": "533110",
    "description": "Townhouse\/Garden Aptmt LRO, over 4 family, no office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "2",
    "classcode": "65133",
    "statcode": "65133",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Townhouse\/Garden Aptmt LRO, over 4 family, incidental office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "3",
    "classcode": "65141",
    "statcode": "65141",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Dwelling - 1 - 4 family, no office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "4",
    "classcode": "65141",
    "statcode": "65141",
    "siccode": "6513",
    "naicscode": "533110",
    "description": "Townhouse\/Garden Aptmt LRO,   - 4 family, no office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "5",
    "classcode": "65142",
    "statcode": "65142",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Dwelling -  Bed & Breakfast",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "6",
    "classcode": "65142",
    "statcode": "65142",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Townhouse\/Garden Aptmt LRO, 1 - 4 family, incidental office\/merc",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "7",
    "classcode": "65142",
    "statcode": "65142",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Dwelling - 1 - 4 family, incidental office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "8",
    "classcode": "65144",
    "statcode": "65144",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Apartment Bldg LRO, flats, common entrance, 1- 4 family, no office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "9",
    "classcode": "65145",
    "statcode": "65145",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Apartment Bldg LRO, flats, common entrance, 1 - 4 family, incidental office\/merc",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "10",
    "classcode": "65146",
    "statcode": "65146",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Apartment Bldg LRO, flats, common entrance, over 4 family, no office\/merc.",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "11",
    "classcode": "65147",
    "statcode": "65147",
    "siccode": "6513",
    "naicscode": "531110",
    "description": "Apartment Bldg LRO, flats, common entrance, over 4 family, incidental off\/merc",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "12",
    "classcode": "69145",
    "statcode": "69145",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Condominium - Dwelling, 1 - 4 family",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "13",
    "classcode": "69145",
    "statcode": "69145",
    "siccode": "6531",
    "naicscode": "531311",
    "description": "Condominium - Apartment Bldg  - flats, common entrances",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "14",
    "classcode": "69145",
    "statcode": "69145",
    "siccode": "6531",
    "naicscode": "531311",
    "description": "Condominium - Townhouse\/Garden Apartment, private entrances",
    "STATE_CODE": "MA",
    "propertytype": "Apartments",
    "subclass": ""
   },
   {
    "id": "15",
    "classcode": "74011",
    "statcode": "74011",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Air Conditioning Systems or Equipment - Dealer or Distributors and Installation, Servicing or Repair (Includes sales and installation of ducts and piping and also includes display rooms and shops) - Office - For combined Air Conditioning\/Heating, see Heating Contractors",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "16",
    "classcode": "74021",
    "statcode": "74021",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Air Conditioning Systems or Equipment - Dealer or Distributors and Installation, Servicing or Repair (Includes sales and installation of ducts and piping and also includes display rooms and shops) - Shop - For combined Air Conditioning\/Heating, see Heating Contractors",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "17",
    "classcode": "74071",
    "statcode": "74071",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Appliances and Accessories - Installation or Service or Repair - Commercial (Not including TV or Radio) - Office - Includes kitchen equipment   For TV, etc., see Electronics",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "18",
    "classcode": "74081",
    "statcode": "74081",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Appliances and Accessories - Installation or Service or Repair - Commercial (Not including TV or Radio) - Shop - Includes kitchen equipment.  For TV, etc., see Electronics",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "19",
    "classcode": "74101",
    "statcode": "74101",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Appliances and Accessories - Installation or Service or Repair - Household (Not including TV or Radio) - Office - Includes kitchen equipment. For TV, etc. see Electronics",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "20",
    "classcode": "74111",
    "statcode": "74111",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Appliances and Accessories - Installation or Service or Repair - Household (Not including TV or Radio) - Shop - Includes kitchen equipment. For TV, etc., see Electronics",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "21",
    "classcode": "74161",
    "statcode": "74161",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Carpentry - Construction of Residential Property - Not exceeding 3 stories in height - Office. MAPFRE restricts this class to Home Improvement Contractors conducting interior remodeling only. No building construction or piercing of the exterior. A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "22",
    "classcode": "74171",
    "statcode": "74171",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Carpentry - Construction of Residential Property - Not exceeding 3 stories in height - Shop. MAPFRE restricts this class to Home Improvement Contractors conducting interior remodeling only. No building construction or piercing of the exterior. A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "23",
    "classcode": "74221",
    "statcode": "74221",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Carpentry Interior (Office) - Subcontracted Operations Excluded. A $500 minimum mandatory Property Damage Liability deductible applies to this classification.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "24",
    "classcode": "74231",
    "statcode": "74231",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Carpentry Interior (Shop) - Subcontracted Operations Excluded. A $500 minimum mandatory Property Damage Liability deductible applies to this classification.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "25",
    "classcode": "74251",
    "statcode": "74251",
    "siccode": "7217",
    "naicscode": "561740",
    "description": "Carpet, Rug, Furniture or Upholstery Cleaning - On customer's premises - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "26",
    "classcode": "74261",
    "statcode": "74261",
    "siccode": "7217",
    "naicscode": "561740",
    "description": "Carpet, Rug, Furniture or Upholstery Cleaning - On customer's premises - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "27",
    "classcode": "74281",
    "statcode": "74281",
    "siccode": "1761",
    "naicscode": "235420",
    "description": "Ceiling or Wall Installation - Metal only (Other than Metal should be classified as Dry Wall or Wallboard Installation or Carpentry) - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "28",
    "classcode": "74291",
    "statcode": "74291",
    "siccode": "1761",
    "naicscode": "235420",
    "description": "Ceiling or Wall Installation - Metal only (Other than Metal should be classified as Dry Wall or Wallboard Installation or Carpentry) - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "29",
    "classcode": "74341",
    "statcode": "74341",
    "siccode": "1771",
    "naicscode": "235710",
    "description": "Concrete Construction (3) - Office - This class contemplates the construction of and set of of forms and pouring of concrete. It does not include excavation.  For excavation, see CPP program",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "30",
    "classcode": "74351",
    "statcode": "74351",
    "siccode": "1771",
    "naicscode": "235710",
    "description": "Concrete Construction (3) - Shop - This class contemplates the construction of and set up of forms and pouring of concrete. It does not include excavation. For excavation, see CPP program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "31",
    "classcode": "74361",
    "statcode": "74361",
    "siccode": "1700",
    "naicscode": "235420",
    "description": "Permanent Yards - Maintenance or Storage (9)",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": ""
   },
   {
    "id": "32",
    "classcode": "74411",
    "statcode": "74411",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Door, Window or Assembled Millwork - Installation - Metal only (Other than metal should be classified as Carpentry) - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "33",
    "classcode": "74421",
    "statcode": "74421",
    "siccode": "1751",
    "naicscode": "235510",
    "description": "Door, Window or Assembled Millwork - Installation - Metal only (Other than metal should be classified as Carpentry) - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "34",
    "classcode": "74471",
    "statcode": "74471",
    "siccode": "1771",
    "naicscode": "235710",
    "description": "Driveway, Parking Area or Sidewalk Repair - Paving or Re-paving (Not including clearing of right-of-way, earth or rock excavation and filling or grading of land) - Office - For excavation and grading, refer to CPP Program",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "35",
    "classcode": "74481",
    "statcode": "74481",
    "siccode": "1771",
    "naicscode": "235710",
    "description": "Driveway, Parking Area or Sidewalk Repair - Paving or Re-paving (Not including clearing of right-of-way, earth or rock excavation and filling or grading of land) - Shop - For excavation and grading, refer to CPP Program",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "36",
    "classcode": "74501",
    "statcode": "74501",
    "siccode": "1742",
    "naicscode": "235420",
    "description": "Dry Wall or Wallboard Installation - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "37",
    "classcode": "74511",
    "statcode": "74511",
    "siccode": "1742",
    "naicscode": "235420",
    "description": "Dry Wall or Wallboard Installation - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "38",
    "classcode": "74541",
    "statcode": "74541",
    "siccode": "1731",
    "naicscode": "235310",
    "description": "Electrical Work - Within Buildings (4) - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "39",
    "classcode": "74561",
    "statcode": "74561",
    "siccode": "1731",
    "naicscode": "235310",
    "description": "Electrical Work - Within Buildings (4) - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "40",
    "classcode": "74591",
    "statcode": "74591",
    "siccode": "1799",
    "naicscode": "235990",
    "description": "Fence Erection Contractors - (Only applies to risks that install or erect fences) - Office - Residential and commercial locations only",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "41",
    "classcode": "74601",
    "statcode": "74601",
    "siccode": "1799",
    "naicscode": "235990",
    "description": "Fence Erection Contractors - (Only applies to risks that install or erect fences) - Shop - Residential and commercial locations only",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "42",
    "classcode": "74651",
    "statcode": "74651",
    "siccode": "1752",
    "naicscode": "235520",
    "description": "Floor Covering Installation - Not Ceramic Tile or Stone - Office - Includes carpets. Does not include wood flooring.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "43",
    "classcode": "74661",
    "statcode": "74661",
    "siccode": "1752",
    "naicscode": "235520",
    "description": "Floor Covering Installation - Not Ceramic Tile or Stone - Shop - Includes carpets. Does not include wood flooring.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "44",
    "classcode": "74681",
    "statcode": "74681",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Furniture or Fixtures - Installation in Offices or Stores - Portable - Metal or Wood -Office - Includes office cubical and retail displays systems.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "45",
    "classcode": "74691",
    "statcode": "74691",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "Furniture or Fixtures - Installation in Offices or Stores - Portable - Metal or Wood - Shop - Includes office cubical and retail display systems.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "46",
    "classcode": "74741",
    "statcode": "74741",
    "siccode": "1793",
    "naicscode": "235920",
    "description": "Glass Dealers and Glaziers - Sales and Installation (Includes bending, grinding, beveling or silvering of plate glass) - Office - Applies if installation receipts are greater than 25% of gross. See Retail Glass if installation is less.  For automotive glass installation, see Garage Repair Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "47",
    "classcode": "74751",
    "statcode": "74751",
    "siccode": "1793",
    "naicscode": "235920",
    "description": "Glass Dealers and Glaziers - Sales and Installation (Includes bending, grinding, beveling or silvering of plate glass) - Shop - Applies if installation receipts are greater than 25% of gross. See Retail Glass if installation is less.  For automotive glass installation, see Garage Repair Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "48",
    "classcode": "74771",
    "statcode": "74771",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Heating or Combined Heating and Air Conditioning Systems or Equipment - Dealers or Distributors and Installation, Servicing or Repair - No Liquefied Petroleum Gas (LPG) Equipment Sales or Work (Includes sales and installation of ducts and piping and also includes display rooms and shops) - Office - MAPFRE allows incidental (10%) gas work",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "49",
    "classcode": "74781",
    "statcode": "74781",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Heating or Combined Heating and Air Conditioning Systems or Equipment - Dealers or Distributors and Installation, Servicing or Repair - No Liquefied Petroleum Gas (LPG) Equipment Sales or Work (Includes sales and installation of ducts and piping and also includes display rooms and shops) - Shop. MAPFRE allows incidental (10%) gas work.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "50",
    "classcode": "74831",
    "statcode": "74831",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "House Furnishings Installation - Not Otherwise Classified (Includes incidental upholstering and floor covering installation) - Office - Also includes installation of window treatments",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "51",
    "classcode": "74841",
    "statcode": "74841",
    "siccode": "1799",
    "naicscode": "23599",
    "description": "House Furnishings Installation - Not Otherwise Classified (Includes incidental upholstering and floor covering installation) - Shop - Also includes instalaltion of window treatments",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "52",
    "classcode": "74861",
    "statcode": "74861",
    "siccode": "7389",
    "naicscode": "541410",
    "description": "Interior Decorators - Office - For consulting services, see Office Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "53",
    "classcode": "74871",
    "statcode": "74871",
    "siccode": "7389",
    "naicscode": "541410",
    "description": "Interior Decorators - Shop - For consulting services, see Office Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "54",
    "classcode": "74891",
    "statcode": "74891",
    "siccode": "782",
    "naicscode": "561730",
    "description": "Landscape Gardening - No Tree Removal or Excavation (5) - Office - MAPFRE allows tree trimming from the ground and digging for the instaltion of product.  Land grading is not permitted.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "55",
    "classcode": "74901",
    "statcode": "74901",
    "siccode": "782",
    "naicscode": "561730",
    "description": "Landscape Gardening - No Tree Removal or Excavation (5) - Shop - MAPFRE  allows tree trimming from the ground and digging for the instaltion of product.  Land grading is not permitted.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "56",
    "classcode": "74951",
    "statcode": "74951",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Lawn Sprinkler Installation - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "57",
    "classcode": "74961",
    "statcode": "74961",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Lawn Sprinkler Installation - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "58",
    "classcode": "75511",
    "statcode": "75511",
    "siccode": "1741",
    "naicscode": "235410",
    "description": "Masonry - Office - Limitation to 3 story buildings applies.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "59",
    "classcode": "75521",
    "statcode": "75521",
    "siccode": "1741",
    "naicscode": "235410",
    "description": "Masonry - Shop - Limitation to 3 story buildings applies.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "60",
    "classcode": "75541",
    "statcode": "75541",
    "siccode": "1791",
    "naicscode": "235910",
    "description": "Metal Erection - Decorative or Artistic (6) - Office - Fire escape installation and security grates are not permitted.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "61",
    "classcode": "75551",
    "statcode": "75551",
    "siccode": "1791",
    "naicscode": "235910",
    "description": "Metal Erection - Decorative or Artistic (6) - Shop - Fire escape installation and security grates are not permitted.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "62",
    "classcode": "75601",
    "statcode": "75601",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Painting - Exterior - Buildings or Structures - 3 stories or less in height (Not Otherwise Classified) (7) - Office - No lead paint removal",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "63",
    "classcode": "75611",
    "statcode": "75611",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Painting - Exterior - Buildings or Structures - 3 stories or less in height (Not Otherwise Classified) (7) - Shop - No lead paint removal",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "64",
    "classcode": "75631",
    "statcode": "75631",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Painting - Interior Buildings or Structures (8) - Office - No lead paint removal",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "65",
    "classcode": "75641",
    "statcode": "75641",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Painting - Interior Buildings or Structures (8) - Shop - No lead paint removal",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "66",
    "classcode": "75691",
    "statcode": "75691",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Paper Hanging - Office",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "67",
    "classcode": "75701",
    "statcode": "75701",
    "siccode": "1721",
    "naicscode": "235210",
    "description": "Paper Hanging - Shop",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "68",
    "classcode": "75751",
    "statcode": "75751",
    "siccode": "1742",
    "naicscode": "235420",
    "description": "Plastering or Stucco Work - Office - No EIFS work",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "69",
    "classcode": "75761",
    "statcode": "75761",
    "siccode": "1742",
    "naicscode": "235420",
    "description": "Plastering or Stucco Work - Shop - No EIFS work",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "70",
    "classcode": "75781",
    "statcode": "75781",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Plumbing - Commercial (Office) - A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "71",
    "classcode": "75791",
    "statcode": "75791",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Plumbing - Commercial (Shop) - A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "72",
    "classcode": "75811",
    "statcode": "75811",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Plumbing - Residential or Domestic (Office) - A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "73",
    "classcode": "75821",
    "statcode": "75821",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Plumbing - Residential or Domestic (Shop) - A $500 minimum mandatory Property Damage Liability deductible applies to this classification",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "74",
    "classcode": "75871",
    "statcode": "75871",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Refrigeration Systems or Equipment - Dealers and Distributors and Installation, Servicing or Repair - Commercial (13) - Office - This class includes incidental ducts and piping and also includes incidental shop and display.  If installation receipts are less than 25% of the gross, see the Retail Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Office"
   },
   {
    "id": "75",
    "classcode": "75881",
    "statcode": "75881",
    "siccode": "1711",
    "naicscode": "235110",
    "description": "Refrigeration Systems or Equipment - Dealers and Distributors and Installation, Servicing or Repair - Commercial (13) - Shop - This class includes incidental ducts and piping. If installation receipts are less than 25% of the gross, see the Retail Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "76",
    "classcode": "75961",
    "statcode": "75961",
    "siccode": "7699",
    "naicscode": "562991",
    "description": "Septic Tank Systems - Cleaning - Class includes repair, but does not include excavation. For excavation, see CPP Program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "77",
    "classcode": "75971",
    "statcode": "75971",
    "siccode": "7699",
    "naicscode": "562991",
    "description": "Septic Tank Systems - Cleaning - Class includes repair, but does not include excavation. For excavation, see CPP program.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "78",
    "classcode": "76021",
    "statcode": "76021",
    "siccode": "1761",
    "naicscode": "235610",
    "description": "Siding Installation - 3 stories or less in height (Wood siding installation should be classified as Carpentry) - No roofing is permitted.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "79",
    "classcode": "76031",
    "statcode": "76031",
    "siccode": "1761",
    "naicscode": "235610",
    "description": "Siding Installation - 3 stories or less in height (Wood siding installation should be classified as Carpentry) - MAPFRE is generally not a market for these operations.  Call Underwriter for exception if no roofing is done.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "80",
    "classcode": "76051",
    "statcode": "76051",
    "siccode": "7389",
    "naicscode": "541890",
    "description": "Sign Painting or Lettering - Inside of Building - No Spray Painting (Includes shop operations and the existence hazard of signs located away from the insured's premises) - MAPFRE allows incidental (10%) outdoor installation.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "81",
    "classcode": "76061",
    "statcode": "76061",
    "siccode": "7389",
    "naicscode": "541890",
    "description": "Sign Painting or Lettering - Inside of Building - No Spray Painting (Includes shop operations and the existence hazard of signs located away from the insured's premises) - MAPFRE allows incidental (10%) outdoor installation.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "82",
    "classcode": "76111",
    "statcode": "76111",
    "siccode": "1743",
    "naicscode": "235430",
    "description": "Tile, Stone, Marble Mosaic or Terrazzo Work - Interior Construction (Includes incidental exterior work - MAPFRE extends this class to exterior work.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "83",
    "classcode": "76121",
    "statcode": "76121",
    "siccode": "1743",
    "naicscode": "235430",
    "description": "Tile, Stone, Marble Mosaic or Terrazzo Work - Interior Construction (Includes incidental exterior work - MAPFRE extends this class to exterior work.",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "84",
    "classcode": "76171",
    "statcode": "76171",
    "siccode": "1799",
    "naicscode": "561720",
    "description": "Window Cleaning - 3 stories or less in height \"office\"",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "85",
    "classcode": "76181",
    "statcode": "76181",
    "siccode": "1799",
    "naicscode": "561720",
    "description": "Window Cleaning - 3 stories or less in height \"shop\"",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "86",
    "classcode": "76221",
    "statcode": "76221",
    "siccode": "7349",
    "naicscode": "561720",
    "description": "Residential Cleaning Services - MAPFRE extends this class to office cleaning",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "87",
    "classcode": "76231",
    "statcode": "76231",
    "siccode": "7349",
    "naicscode": "561720",
    "description": "Residential Cleaning Services - MAPFRE extends this class to office cleaning",
    "STATE_CODE": "MA",
    "propertytype": "Contractors",
    "subclass": "Shop"
   },
   {
    "id": "88",
    "classcode": "09331",
    "statcode": "09331",
    "siccode": "5411",
    "naicscode": "445120",
    "description": "Convenience Food Stores - With Limited Cooking Restaurant - No Gasoline Sales",
    "STATE_CODE": "MA",
    "propertytype": "Convenience Food\/Grocery\/Supermarkets",
    "subclass": ""
   },
   {
    "id": "89",
    "classcode": "54136",
    "statcode": "54136",
    "siccode": "5411",
    "naicscode": "445120",
    "description": "Convenience Food Stores - Without Gasoline Sales - No Restaurant",
    "STATE_CODE": "MA",
    "propertytype": "Convenience Food\/Grocery\/Supermarkets",
    "subclass": ""
   },
   {
    "id": "90",
    "classcode": "09521",
    "statcode": "09521",
    "siccode": "7212",
    "naicscode": "812320",
    "description": "Laundry and Dry Cleaning Stores - Using synthetic solvents (including perchloroethylene or other synthetic solvents) and having less than 3 pick-up stations",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "91",
    "classcode": "50333",
    "statcode": "50333",
    "siccode": "5611",
    "naicscode": "448150",
    "description": "Clothing or Wearing Apparel - Retail - Men's and Boys' Hats and Caps",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "92",
    "classcode": "50811",
    "statcode": "50811",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Precision and Scientific Tools and Instruments - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "93",
    "classcode": "50812",
    "statcode": "50812",
    "siccode": "2700",
    "naicscode": "32311",
    "description": "Bookbinding and Printing Supplies - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "94",
    "classcode": "50813",
    "statcode": "50813",
    "siccode": "5044",
    "naicscode": "421420",
    "description": "Equipment, Fixtures or Supplies Distributors - Office and Store Equipment - If installation receipts exceed 25%, see the Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "95",
    "classcode": "50813",
    "statcode": "50813",
    "siccode": "5046",
    "naicscode": "421440",
    "description": "Equipment, Fixtures or Supplies Distributors - Restaurant, Bars and Hotel Equipment - If installation receipts exceed 25% see the Contractor Program",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "96",
    "classcode": "50815",
    "statcode": "50815",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Medical, Hospital and Surgical Supply - Retail Only - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "97",
    "classcode": "50819",
    "statcode": "50819",
    "siccode": "5251",
    "naicscode": "444210",
    "description": "Powered Equipment Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "98",
    "classcode": "50925",
    "statcode": "50925",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Office Machines or Appliances - Retail - No Repair",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "99",
    "classcode": "50943",
    "statcode": "50943",
    "siccode": "5211",
    "naicscode": "444190",
    "description": "Wood Products - Not Otherwise Classified - Retail only - Contact Underwriter with a list of products",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "100",
    "classcode": "52114",
    "statcode": "52114",
    "siccode": "5211",
    "naicscode": "444190",
    "description": "Building Materials - Contractors Equipment Dealers - Other Than Secondhand Material - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "101",
    "classcode": "52322",
    "statcode": "52322",
    "siccode": "5231",
    "naicscode": "444120",
    "description": "Paint, Wallpaper or Wallcovering Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "102",
    "classcode": "52512",
    "statcode": "52512",
    "siccode": "5251",
    "naicscode": "444130",
    "description": "Hardware and Tools - Retail - MAPFRE is generally not a market for this products exposure.  Call Underwriter for exceptions.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "103",
    "classcode": "52512",
    "statcode": "52522",
    "siccode": "7699",
    "naicscode": "561622",
    "description": "Locksmiths - Includes shop and incidental installation",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "104",
    "classcode": "53127",
    "statcode": "53127",
    "siccode": "5311",
    "naicscode": "452110",
    "description": "Department Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "105",
    "classcode": "53315",
    "statcode": "53315",
    "siccode": "5331",
    "naicscode": "452990",
    "description": "Variety Stores - Discount Houses",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "106",
    "classcode": "53317",
    "statcode": "53317",
    "siccode": "5331",
    "naicscode": "452990",
    "description": "Variety Stores - Five and Ten Cent Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "107",
    "classcode": "53983",
    "statcode": "53983",
    "siccode": "5399",
    "naicscode": "453310",
    "description": "Army and Navy Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "108",
    "classcode": "53985",
    "statcode": "53985",
    "siccode": "5949",
    "naicscode": "451130",
    "description": "Dry Goods Dealers - Retail - Including Fabrics, Yarn and Piece Goods - (New Goods Only)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "109",
    "classcode": "53989",
    "statcode": "53989",
    "siccode": "5211",
    "naicscode": "444110",
    "description": "Home Improvement Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "110",
    "classcode": "54016",
    "statcode": "09071",
    "siccode": "5411",
    "naicscode": "445110",
    "description": "Delicatessens - Primarily retailing a range of grocery items and meats",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "111",
    "classcode": "54127",
    "statcode": "54127",
    "siccode": "5499",
    "naicscode": "445110",
    "description": "Health or Natural Food Stores - With an area at least 4000 square feet",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "112",
    "classcode": "54136",
    "statcode": "54136",
    "siccode": "5499",
    "naicscode": "445110",
    "description": "Health or Natural Food Stores - With an area less than 4000 square feet",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "113",
    "classcode": "54216",
    "statcode": "54216",
    "siccode": "5421",
    "naicscode": "445210",
    "description": "Meat, Fish, Poultry or Seafood - Retail - Fish or Seafood",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "114",
    "classcode": "54216",
    "statcode": "54216",
    "siccode": "5421",
    "naicscode": "445220",
    "description": "Meat, Fish, Poultry or Seafood - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "115",
    "classcode": "54221",
    "statcode": "54221",
    "siccode": "5411",
    "naicscode": "445110",
    "description": "Supermarkets With an area at least 4,000 square feet - Without Gasoline Sales",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "116",
    "classcode": "54241",
    "statcode": "54241",
    "siccode": "5411",
    "naicscode": "445110",
    "description": "Supermarkets With an area less than 4,000 square feet - Without Gasoline Sales",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "117",
    "classcode": "54315",
    "statcode": "54315",
    "siccode": "5431",
    "naicscode": "445230",
    "description": "Fruit or Vegetable - Dealers",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "118",
    "classcode": "54321",
    "statcode": "54321",
    "siccode": "5411",
    "naicscode": "445110",
    "description": "Grocery - Stores - With an area at least 4,000 square feet - Without Gasoline Sales",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "119",
    "classcode": "54341",
    "statcode": "54341",
    "siccode": "5411",
    "naicscode": "445110",
    "description": "Grocery - Stores - With an area less than 4,000 square feet - Without Gasoline Sales",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "120",
    "classcode": "54457",
    "statcode": "54457",
    "siccode": "5441",
    "naicscode": "445292",
    "description": "Candy or Confectionary Stores - No Manufacturing on Premises",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "121",
    "classcode": "54467",
    "statcode": "54467",
    "siccode": "2066",
    "naicscode": "311330",
    "description": "Candy or Confectionary Stores - Confectionary Manufacturing from Purchased Chocolate on Premises",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "122",
    "classcode": "54477",
    "statcode": "54477",
    "siccode": "2064",
    "naicscode": "311340",
    "description": "Candy or Confectionary Stores - Nonchocolate Confectionary Manufacturing on Premises",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "123",
    "classcode": "54516",
    "statcode": "54516",
    "siccode": "5451",
    "naicscode": "445299",
    "description": "Dairy Products or Butter and Egg Stores (Including Ice Cream)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "124",
    "classcode": "54606",
    "statcode": "54606",
    "siccode": "5461",
    "naicscode": "445291",
    "description": "Bakeries - Retail - No baking on premises",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "125",
    "classcode": "55313",
    "statcode": "55313",
    "siccode": "5531",
    "naicscode": "441310",
    "description": "Automobile Parts and Supplies - Retail Stores (Including Tires)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "126",
    "classcode": "55313",
    "statcode": "55313",
    "siccode": "5531",
    "naicscode": "441320",
    "description": "Tire Dealers - Incidental outdoor tire storage only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "127",
    "classcode": "55973",
    "statcode": "55973",
    "siccode": "5551",
    "naicscode": "441222",
    "description": "Boat Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "128",
    "classcode": "56113",
    "statcode": "56113",
    "siccode": "5611",
    "naicscode": "448150",
    "description": "Clothing or Wearing Apparel - Retail - Haberdashery and Men's Furnishings",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "129",
    "classcode": "56114",
    "statcode": "56114",
    "siccode": "5611",
    "naicscode": "448110",
    "description": "Clothing or Wearing Apparel - Retail - Clothing - Men's and Boys' (Coats and Suits)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "130",
    "classcode": "56214",
    "statcode": "56214",
    "siccode": "5621",
    "naicscode": "448120",
    "description": "Clothing or Wearing Apparel - Retail - Clothing - Ladies' and Girls' (Coats, Suits and Dresses)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "131",
    "classcode": "56311",
    "statcode": "56311",
    "siccode": "5949",
    "naicscode": "451130",
    "description": "Clothing or Wearing Apparel - Retail - Fabric Stores (Including Millinery and Trimmings)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "132",
    "classcode": "56311",
    "statcode": "56311",
    "siccode": "5949",
    "naicscode": "451130",
    "description": "Fabric - Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "133",
    "classcode": "56312",
    "statcode": "56312",
    "siccode": "5632",
    "naicscode": "448190",
    "description": "Clothing or Wearing Apparel - Retail - Ladies' Undergarments and Lingerie",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "134",
    "classcode": "56313",
    "statcode": "56313",
    "siccode": "5632",
    "naicscode": "448190",
    "description": "Clothing or Wearing Apparel - Retail - Hosiery",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "135",
    "classcode": "56319",
    "statcode": "56319",
    "siccode": "5632",
    "naicscode": "448190",
    "description": "Clothing or Wearing Apparel - Retail - Ladies' Specialty Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "136",
    "classcode": "56325",
    "statcode": "56325",
    "siccode": "5651",
    "naicscode": "448140",
    "description": "Clothing or Wearing Apparel - Retail - Family Clothing Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "137",
    "classcode": "56413",
    "statcode": "56413",
    "siccode": "5641",
    "naicscode": "448130",
    "description": "Clothing or Wearing Apparel - Retail - Children's and Infants' Wear",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "138",
    "classcode": "56613",
    "statcode": "56613",
    "siccode": "5661",
    "naicscode": "451110",
    "description": "Clothing or Wearing Apparel - Retail - Shoe Stores - Children's, Ladies and Men's",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "139",
    "classcode": "56613",
    "statcode": "56613",
    "siccode": "5661",
    "naicscode": "451110",
    "description": "Shoe Stores -Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "140",
    "classcode": "56814",
    "statcode": "56814",
    "siccode": "5632",
    "naicscode": "448190",
    "description": "Clothing or Wearing Apparel - Retail - Furs (Including Pelts) - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "141",
    "classcode": "56814",
    "statcode": "56814",
    "siccode": "5632",
    "naicscode": "448190",
    "description": "Fur - Garments and Pelts - Retail Only - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "142",
    "classcode": "56992",
    "statcode": "56992",
    "siccode": "5948",
    "naicscode": "448320",
    "description": "Leather Products or Hide Stores - Retail only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "143",
    "classcode": "57121",
    "statcode": "57121",
    "siccode": "5712",
    "naicscode": "442110",
    "description": "Furniture - Upholstered - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "144",
    "classcode": "57128",
    "statcode": "57128",
    "siccode": "5712",
    "naicscode": "442110",
    "description": "Furniture - Wood or Metal - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "145",
    "classcode": "57134",
    "statcode": "57134",
    "siccode": "5713",
    "naicscode": "442210",
    "description": "Floor Covering - Stores - Wood or Ceramic Tile Only - If installation receipts exceed 25% of gross, see Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "146",
    "classcode": "57134",
    "statcode": "57134",
    "siccode": "5713",
    "naicscode": "444190",
    "description": "Floor Covering - Stores - Except Wood or Ceramic Tile Only - If installation receipts exceed 25% of gross, see Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "147",
    "classcode": "57155",
    "statcode": "57155",
    "siccode": "5231",
    "naicscode": "444190",
    "description": "Glass Dealers and Glaziers - Retail Only - If installation receipts exceed 25% of the gross, see the Contractor's Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "148",
    "classcode": "57223",
    "statcode": "57223",
    "siccode": "5722",
    "naicscode": "443111",
    "description": "Sewing Machine Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "149",
    "classcode": "57224",
    "statcode": "57224",
    "siccode": "5710",
    "naicscode": "442299",
    "description": "Home Furnishings Stores - Includes white goods.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "150",
    "classcode": "57224",
    "statcode": "57224",
    "siccode": "5722",
    "naicscode": "443111",
    "description": "Appliance Stores - Household Appliances and Home Furnishings - Includes kitchen appliances. If installation, service ore repair exceed 25% of gross to see either Contractor OR Mercantile programs.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "151",
    "classcode": "57326",
    "statcode": "57326",
    "siccode": "5731",
    "naicscode": "443112",
    "description": "Appliance Stores - Radio, Television and Phonographic Stores (including parts and supplies)",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "152",
    "classcode": "57326",
    "statcode": "57326",
    "siccode": "5731",
    "naicscode": "443112",
    "description": "Electronics Stores - TV, radio, cell phone, pager, home entertainment systems, etc. Includes incidental installation.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "153",
    "classcode": "57326",
    "statcode": "57326",
    "siccode": "5734",
    "naicscode": "443120",
    "description": "Computer Stores - Includes hardware, software, and gaming systems.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "154",
    "classcode": "57334",
    "statcode": "57334",
    "siccode": "5736",
    "naicscode": "451140",
    "description": "Musical Instrument Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "155",
    "classcode": "57338",
    "statcode": "57338",
    "siccode": "5735",
    "naicscode": "451220",
    "description": "Music Stores - Pre-recorded",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "156",
    "classcode": "57338",
    "statcode": "57338",
    "siccode": "5735",
    "naicscode": "451220",
    "description": "Video Stores - Sales",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "157",
    "classcode": "57338",
    "statcode": "57338",
    "siccode": "7841",
    "naicscode": "532230",
    "description": "Video Stores - Rental",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "158",
    "classcode": "59116",
    "statcode": "59116",
    "siccode": "5912",
    "naicscode": "446110",
    "description": "Drugstores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "159",
    "classcode": "59215",
    "statcode": "59215",
    "siccode": "5921",
    "naicscode": "445310",
    "description": "Beverage Stores - Liquor and Wine - Liquor Liability coverage is available",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "160",
    "classcode": "59325",
    "statcode": "59325",
    "siccode": "5932",
    "naicscode": "453310",
    "description": "Antique Stores - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "161",
    "classcode": "59425",
    "statcode": "59425",
    "siccode": "5942",
    "naicscode": "451211",
    "description": "Books and Magazines Stores - New",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "162",
    "classcode": "59425",
    "statcode": "59425",
    "siccode": "5932",
    "naicscode": "453310",
    "description": "Books and Magazines Stores - Used",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "163",
    "classcode": "59435",
    "statcode": "59435",
    "siccode": "5943",
    "naicscode": "453210",
    "description": "Stationery or Paper Products Distributors - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "164",
    "classcode": "59505",
    "statcode": "59505",
    "siccode": "5941",
    "naicscode": "451110",
    "description": "Bicycle Shops - Retail - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "165",
    "classcode": "59505",
    "statcode": "59505",
    "siccode": "5941",
    "naicscode": "811490",
    "description": "Bicycle Shops - Repair and Maintenance Shops without Retail - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "166",
    "classcode": "59526",
    "statcode": "59526",
    "siccode": "5699",
    "naicscode": "451110",
    "description": "Clothing or Wearing Apparel - Retail - Sporting Goods and Athletic Apparel",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "167",
    "classcode": "59526",
    "statcode": "59526",
    "siccode": "5941",
    "naicscode": "451110",
    "description": "Sporting Goods or Athletic Equipment Stores (Including Apparel) - Stores selling equipment for contact sports, skiing,  hunting, or \"extreme\" sports are ineligible.  Sale of golf and tennis equipment is eligible. Contact your underwriter to discuss.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "168",
    "classcode": "59625",
    "statcode": "59625",
    "siccode": "5261",
    "naicscode": "444220",
    "description": "Seed Merchants (Including or excluding misdelivery or germination failure.) - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "169",
    "classcode": "59625",
    "statcode": "59625",
    "siccode": "5999",
    "naicscode": "444220",
    "description": "Feed, Grain or Hay Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "170",
    "classcode": "59685",
    "statcode": "59685",
    "siccode": "5992",
    "naicscode": "453110",
    "description": "Florist - Retail - The Florist Extension Endorsement is Automatically included with this classification",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "171",
    "classcode": "59698",
    "statcode": "59698",
    "siccode": "5261",
    "naicscode": "444220",
    "description": "Gardening and Light Farming Supply - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "172",
    "classcode": "59715",
    "statcode": "59715",
    "siccode": "5944",
    "naicscode": "448150",
    "description": "Jewelry - Retail - Costume",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "173",
    "classcode": "59715",
    "statcode": "59715",
    "siccode": "5944",
    "naicscode": "448310",
    "description": "Jewelry - Retail - Precious - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "174",
    "classcode": "59906",
    "statcode": "59906",
    "siccode": "5993",
    "naicscode": "453991",
    "description": "Tobacco Products Distributors - Retail - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "175",
    "classcode": "59935",
    "statcode": "59935",
    "siccode": "5994",
    "naicscode": "451212",
    "description": "Newsstands",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "176",
    "classcode": "59954",
    "statcode": "59954",
    "siccode": "5995",
    "naicscode": "446130",
    "description": "Optical Goods - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "177",
    "classcode": "59955",
    "statcode": "59955",
    "siccode": "5946",
    "naicscode": "443130",
    "description": "Camera and Photographic Equipment - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "178",
    "classcode": "59955",
    "statcode": "59965",
    "siccode": "5946",
    "naicscode": "443130",
    "description": "Photographic Equipment - Retail only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "179",
    "classcode": "59974",
    "statcode": "59944",
    "siccode": "5999",
    "naicscode": "446199",
    "description": "Hearing Aid - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "180",
    "classcode": "59983",
    "statcode": "59983",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Refrigeration Equipment - Commercial - Retail - If installation receipts exceed 25% of gross, see the Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "181",
    "classcode": "59991",
    "statcode": "59991",
    "siccode": "5999",
    "naicscode": "446120",
    "description": "Cosmetic, Hair or Skin Preparation - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "182",
    "classcode": "59992",
    "statcode": "59992",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Collectibles and Memorabilia - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "183",
    "classcode": "59993",
    "statcode": "59993",
    "siccode": "5699",
    "naicscode": "448150",
    "description": "Clothing or Wearing Apparel - Retail - Wigs",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "184",
    "classcode": "59993",
    "statcode": "59993",
    "siccode": "5699",
    "naicscode": "448150",
    "description": "Wigs - Retail only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "185",
    "classcode": "59994",
    "statcode": "59994",
    "siccode": "5947",
    "naicscode": "453220",
    "description": "Gift Shops",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "186",
    "classcode": "59995",
    "statcode": "59995",
    "siccode": "5945",
    "naicscode": "451120",
    "description": "Hobby, Craft or Artists' Supply - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "187",
    "classcode": "59996",
    "statcode": "59996",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Trophy Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "188",
    "classcode": "59997",
    "statcode": "59997",
    "siccode": "5999",
    "naicscode": "453910",
    "description": "Pet Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "189",
    "classcode": "59998",
    "statcode": "59998",
    "siccode": "5945",
    "naicscode": "451120",
    "description": "Toys - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "190",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "442299",
    "description": "Painting, Picture or Frame Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "191",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5075",
    "naicscode": "443111",
    "description": "Air Conditioning Equipment - Retail Only - If installation receipts exceed 25% of gross, see Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "192",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5211",
    "naicscode": "444190",
    "description": "Fence Dealers - If installation receipts exceed 25% of the gross, see the Contractor Program.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "193",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "444190",
    "description": "Ceramics - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "194",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "444190",
    "description": "Electrical Lighting Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "195",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "444190",
    "description": "Plumbing Supplies and Fixtures - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "196",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5261",
    "naicscode": "444220",
    "description": "Fertilizer Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "197",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5948",
    "naicscode": "448320",
    "description": "Luggage Goods - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "198",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Bone, Horn and Ivory Products - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "199",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Fire Protection Equipment Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "200",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Janitorial Supplies - Retail",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "201",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Marble Products - Retail only - Also Includes all stone products",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "202",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Metal Dealers - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "203",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Retail Stores (Not Otherwise Classified) - Contact your underwriter with a description of merchandise.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "204",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Ship Chandler Stores - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "205",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Straw and Straw Products - Retail Only",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "206",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5999",
    "naicscode": "453998",
    "description": "Swimming Pools - Retail Only - Ineligible unless LRO",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "207",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "7389",
    "naicscode": "453998",
    "description": "Auctions - On premises owned or rented by the insured - Off premises auctions are ineligible.",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "208",
    "classcode": "59999",
    "statcode": "59999",
    "siccode": "5961",
    "naicscode": "454110",
    "description": "Mail Order Houses - Retail Only - For combined Air Conditioning\/Heating, see Heating Contractors",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "209",
    "classcode": "73905",
    "statcode": "73905",
    "siccode": "5961",
    "naicscode": "454110",
    "description": "Catalog or Premium Coupon Redemption Stores",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "210",
    "classcode": "84112",
    "statcode": "84112",
    "siccode": "5999",
    "naicscode": "453920",
    "description": "Art Galleries - Other Than Not-for-profit - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "211",
    "classcode": "84112",
    "statcode": "84112",
    "siccode": "8412",
    "naicscode": "712110",
    "description": "Art Galleries - Not-for-profit - Building and furnishings are eligible. Stock is ineligible",
    "STATE_CODE": "MA",
    "propertytype": "Mercantile Risks",
    "subclass": ""
   },
   {
    "id": "212",
    "classcode": "60989",
    "statcode": "60989",
    "siccode": "6531",
    "naicscode": "531312",
    "description": "Condominiums - Commercial Condominium (Association risk only) - Mercantile",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "213",
    "classcode": "60999",
    "statcode": "60999",
    "siccode": "6531",
    "naicscode": "531312",
    "description": "Condominiums - Office Condominium (Association risk only) - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "214",
    "classcode": "63611",
    "statcode": "63611",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Accounting Services - Except CPAs - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "215",
    "classcode": "63611",
    "statcode": "63611",
    "siccode": "8721",
    "naicscode": "541219",
    "description": "Accounting Services - Except CPAs - Office - Includes Actuarial and Data Mining Services",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "216",
    "classcode": "63621",
    "statcode": "63621",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Accounting Services - Except CPAs - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "217",
    "classcode": "63621",
    "statcode": "63621",
    "siccode": "8721",
    "naicscode": "541219",
    "description": "Accounting Services - Except CPAs - Condominium - Office - Includes Actuarial and Data Mining Services",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "218",
    "classcode": "63631",
    "statcode": "63631",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Accounting Services - CPAs - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "219",
    "classcode": "63631",
    "statcode": "63631",
    "siccode": "8721",
    "naicscode": "541211",
    "description": "Accounting Services - CPAs - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "220",
    "classcode": "63641",
    "statcode": "63641",
    "siccode": "8712",
    "naicscode": "531120",
    "description": "Accounting Services - CPAs - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "221",
    "classcode": "63641",
    "statcode": "63641",
    "siccode": "8721",
    "naicscode": "541211",
    "description": "Accounting Services - CPAs - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "222",
    "classcode": "63651",
    "statcode": "63651",
    "siccode": "7310",
    "naicscode": "531120",
    "description": "Advertising and Related Services - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "223",
    "classcode": "63651",
    "statcode": "63651",
    "siccode": "7310",
    "naicscode": "541810",
    "description": "Advertising and Related Services -Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "224",
    "classcode": "63661",
    "statcode": "63661",
    "siccode": "7310",
    "naicscode": "531120",
    "description": "Advertising and Related Services - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "225",
    "classcode": "63661",
    "statcode": "63661",
    "siccode": "7310",
    "naicscode": "541810",
    "description": "Advertising and Related Services - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "226",
    "classcode": "63671",
    "statcode": "63671",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Bookkeeping Services - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "227",
    "classcode": "63671",
    "statcode": "63671",
    "siccode": "8721",
    "naicscode": "541219",
    "description": "Bookkeeping Services - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "228",
    "classcode": "63681",
    "statcode": "63681",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Bookkeeping Services - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "229",
    "classcode": "63681",
    "statcode": "63681",
    "siccode": "8721",
    "naicscode": "541219",
    "description": "Bookkeeping Services - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "230",
    "classcode": "63691",
    "statcode": "63691",
    "siccode": "7322",
    "naicscode": "531120",
    "description": "Collection Agencies - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "231",
    "classcode": "63691",
    "statcode": "63691",
    "siccode": "7322",
    "naicscode": "561440",
    "description": "Collection Agencies - Office - Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "232",
    "classcode": "63711",
    "statcode": "63711",
    "siccode": "7322",
    "naicscode": "531120",
    "description": "Collection Agencies - Condominium - Office- Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "233",
    "classcode": "63711",
    "statcode": "63711",
    "siccode": "7322",
    "naicscode": "561440",
    "description": "Collection Agencies - Condominium - Office - Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "234",
    "classcode": "63721",
    "statcode": "63721",
    "siccode": "7323",
    "naicscode": "531120",
    "description": "Credit Reporting Agencies - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "235",
    "classcode": "63721",
    "statcode": "63721",
    "siccode": "7323",
    "naicscode": "561450",
    "description": "Credit Reporting Agencies - Office - Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "236",
    "classcode": "63731",
    "statcode": "63731",
    "siccode": "7323",
    "naicscode": "531120",
    "description": "Credit Reporting Agencies - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "237",
    "classcode": "63731",
    "statcode": "63731",
    "siccode": "7323",
    "naicscode": "561450",
    "description": "Credit Reporting Agencies - Condominium - Office - Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "238",
    "classcode": "63741",
    "statcode": "63741",
    "siccode": "7381",
    "naicscode": "531120",
    "description": "Detective or Investigative Agencies - Private - Office- Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "239",
    "classcode": "63751",
    "statcode": "63751",
    "siccode": "7381",
    "naicscode": "531120",
    "description": "Detective or Investigative Agencies - Private - Condominium- Office- Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "240",
    "classcode": "63761",
    "statcode": "63761",
    "siccode": "7361",
    "naicscode": "531120",
    "description": "Employment Agencies - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "241",
    "classcode": "63771",
    "statcode": "63771",
    "siccode": "7361",
    "naicscode": "531120",
    "description": "Employment Agencies - Condominium- Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "242",
    "classcode": "63781",
    "statcode": "63781",
    "siccode": "8710",
    "naicscode": "531120",
    "description": "Engineers or Architects - Consulting - Not engaged in actual construction - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "243",
    "classcode": "63781",
    "statcode": "63781",
    "siccode": "8710",
    "naicscode": "541330",
    "description": "Engineers or Architects - Consulting - Not engaged in actual construction - Office - Also includes Land Surveyors, Draftsmen",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "244",
    "classcode": "63791",
    "statcode": "63791",
    "siccode": "8710",
    "naicscode": "531120",
    "description": "Engineers or Architects - Consulting - Not engaged in actual construction - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "245",
    "classcode": "63791",
    "statcode": "63791",
    "siccode": "8710",
    "naicscode": "541330",
    "description": "Engineers or Architects - Consulting - Not engaged in actual construction - Condominium - Office - Also includes Land Surveyors and Draftsmen",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "246",
    "classcode": "63811",
    "statcode": "63811",
    "siccode": "6324",
    "naicscode": "531120",
    "description": "Health Maintenance Organizations - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "247",
    "classcode": "63811",
    "statcode": "63811",
    "siccode": "6324",
    "naicscode": "621491",
    "description": "Health Maintenance Organizations - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "248",
    "classcode": "63821",
    "statcode": "63821",
    "siccode": "6324",
    "naicscode": "531120",
    "description": "Health Maintenance Organizations - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "249",
    "classcode": "63821",
    "statcode": "63821",
    "siccode": "6324",
    "naicscode": "621491",
    "description": "Health Maintenance Organizations - Condominium - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "250",
    "classcode": "63831",
    "statcode": "63831",
    "siccode": "6411",
    "naicscode": "524298",
    "description": "Inspection and Appraisal Companies - Inspecting for insurance or valuation purposes - Office - Inspecting for insurance or valuation purposes. Includes Public Adjustors",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "251",
    "classcode": "63831",
    "statcode": "63831",
    "siccode": "6411",
    "naicscode": "531120",
    "description": "Inspection and Appraisal Companies - Inspecting for insurance or valuation purposes - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "252",
    "classcode": "63841",
    "statcode": "63841",
    "siccode": "6411",
    "naicscode": "524298",
    "description": "Inspection and Appraisal Companies - Inspecting for insurance or valuation purposes - Condominium - Office - Inspecting for insurance or valuation purposes. Includes Public Adjustors",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "253",
    "classcode": "63841",
    "statcode": "63841",
    "siccode": "6411",
    "naicscode": "531120",
    "description": "Inspection and Appraisal Companies - Inspecting for insurance or valuation purposes - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "254",
    "classcode": "63851",
    "statcode": "63851",
    "siccode": "6411",
    "naicscode": "524210",
    "description": "Insurance Agents - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "255",
    "classcode": "63851",
    "statcode": "63851",
    "siccode": "6411",
    "naicscode": "531120",
    "description": "Insurance Agents - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "256",
    "classcode": "63861",
    "statcode": "63861",
    "siccode": "6411",
    "naicscode": "524210",
    "description": "Insurance Agents - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "257",
    "classcode": "63861",
    "statcode": "63861",
    "siccode": "6411",
    "naicscode": "531120",
    "description": "Insurance Agents - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "258",
    "classcode": "63871",
    "statcode": "63871",
    "siccode": "7389",
    "naicscode": "531120",
    "description": "Interior Decorators - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "259",
    "classcode": "63871",
    "statcode": "63871",
    "siccode": "7389",
    "naicscode": "541410",
    "description": "Interior Decorators - Office - Design consultation only. For installation, see contracting.",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "260",
    "classcode": "63881",
    "statcode": "63881",
    "siccode": "7389",
    "naicscode": "531120",
    "description": "Interior Decorators - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "261",
    "classcode": "63881",
    "statcode": "63881",
    "siccode": "7389",
    "naicscode": "541410",
    "description": "Interior Decorators - Condominium - Office - Design consultation only. For installation, see contracting.",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "262",
    "classcode": "63891",
    "statcode": "63891",
    "siccode": "8631",
    "naicscode": "531120",
    "description": "Labor Union (Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached.) - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "263",
    "classcode": "63891",
    "statcode": "63891",
    "siccode": "8631",
    "naicscode": "813930",
    "description": "Labor Union (Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached.) - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "264",
    "classcode": "63911",
    "statcode": "63911",
    "siccode": "8631",
    "naicscode": "531120",
    "description": "Labor Union - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "265",
    "classcode": "63911",
    "statcode": "63911",
    "siccode": "8631",
    "naicscode": "813930",
    "description": "Labor Union - Condominium - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "266",
    "classcode": "63921",
    "statcode": "63921",
    "siccode": "8111",
    "naicscode": "531120",
    "description": "Lawyers - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "267",
    "classcode": "63921",
    "statcode": "63921",
    "siccode": "8111",
    "naicscode": "541110",
    "description": "Lawyers - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "268",
    "classcode": "63931",
    "statcode": "63931",
    "siccode": "8111",
    "naicscode": "531120",
    "description": "Lawyers - Condominium - Office- Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "269",
    "classcode": "63931",
    "statcode": "63931",
    "siccode": "8111",
    "naicscode": "8111",
    "description": "Lawyers - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "270",
    "classcode": "63941",
    "statcode": "63941",
    "siccode": "8611",
    "naicscode": "531120",
    "description": "Manufacturers' Representatives -Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "271",
    "classcode": "63941",
    "statcode": "63941",
    "siccode": "8611",
    "naicscode": "813910",
    "description": "Manufacturers' Representatives - Office - The products represented must be eligible for a BOP",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "272",
    "classcode": "63951",
    "statcode": "63951",
    "siccode": "8611",
    "naicscode": "531120",
    "description": "Manufacturers' Representatives - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "273",
    "classcode": "63951",
    "statcode": "63951",
    "siccode": "8611",
    "naicscode": "813910",
    "description": "Manufacturers' Representatives - Condominium - Office - The products repreesnted must be eligible for a BOP",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "274",
    "classcode": "63961",
    "statcode": "63961",
    "siccode": "7389",
    "naicscode": "541990",
    "description": "Marine Appraisers or Surveyors - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "275",
    "classcode": "63971",
    "statcode": "63971",
    "siccode": "7389",
    "naicscode": "531120",
    "description": "Marine Appraisers or Surveyors - Condominium- Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "276",
    "classcode": "63981",
    "statcode": "63981",
    "siccode": "8000",
    "naicscode": "531120",
    "description": "Medical Offices - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "277",
    "classcode": "63981",
    "statcode": "63981",
    "siccode": "8000",
    "naicscode": "62111",
    "description": "Medical Offices - Office - This class does not include diagnostic clinics with high value equipment",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "278",
    "classcode": "63991",
    "statcode": "63991",
    "siccode": "8000",
    "naicscode": "531120",
    "description": "Medical Offices - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "279",
    "classcode": "63991",
    "statcode": "63991",
    "siccode": "8000",
    "naicscode": "62111",
    "description": "Medical Offices - Condominium - Office - This class does not include diagnostic clinics with high value equipment",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "280",
    "classcode": "64011",
    "statcode": "64011",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Payroll Accounting Services - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "281",
    "classcode": "64011",
    "statcode": "64011",
    "siccode": "8721",
    "naicscode": "541214",
    "description": "Payroll Accounting Services - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "282",
    "classcode": "64021",
    "statcode": "64021",
    "siccode": "8721",
    "naicscode": "531120",
    "description": "Payroll Accounting Services - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "283",
    "classcode": "64021",
    "statcode": "64021",
    "siccode": "8721",
    "naicscode": "541214",
    "description": "Payroll Accounting Services - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "284",
    "classcode": "64031",
    "statcode": "64031",
    "siccode": "8651",
    "naicscode": "531120",
    "description": "Political Campaign Headquarters or Offices - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "285",
    "classcode": "64031",
    "statcode": "64031",
    "siccode": "8651",
    "naicscode": "813940",
    "description": "Political Campaign Headquarters or Offices - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "286",
    "classcode": "64051",
    "statcode": "64051",
    "siccode": "8651",
    "naicscode": "531120",
    "description": "Political Campaign Headquarters or Offices - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "287",
    "classcode": "64051",
    "statcode": "64051",
    "siccode": "8651",
    "naicscode": "813940",
    "description": "Political Campaign Headquarters or Offices - Condominium - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "288",
    "classcode": "64061",
    "statcode": "64061",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Real Estate Agents - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "289",
    "classcode": "64061",
    "statcode": "64061",
    "siccode": "6531",
    "naicscode": "531210",
    "description": "Real Estate Agents - Office - Real estate management and development operations are not eligible.",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "290",
    "classcode": "64071",
    "statcode": "64071",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Real Estate Agents - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "291",
    "classcode": "64071",
    "statcode": "64071",
    "siccode": "6531",
    "naicscode": "531210",
    "description": "Real Estate Agents - Condominium - Office - Real estate management and development operations are not eligible.",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "292",
    "classcode": "64081",
    "statcode": "64081",
    "siccode": "7381",
    "naicscode": "531120",
    "description": "Security and Patrol Agencies (Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached.) - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "293",
    "classcode": "64091",
    "statcode": "64091",
    "siccode": "7381",
    "naicscode": "531120",
    "description": "Security and Patrol Agencies (Personal Injury And Advertising Injury Endorsement BP 04 37 must be attached.) - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "294",
    "classcode": "64121",
    "statcode": "64121",
    "siccode": "7922",
    "naicscode": "531120",
    "description": "Ticket Agencies - Theatrical -Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "295",
    "classcode": "64121",
    "statcode": "64121",
    "siccode": "7922",
    "naicscode": "561599",
    "description": "Ticket Agencies - Theatrical - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "296",
    "classcode": "64131",
    "statcode": "64131",
    "siccode": "7922",
    "naicscode": "531120",
    "description": "Ticket Agencies - Theatrical - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "297",
    "classcode": "64131",
    "statcode": "64131",
    "siccode": "7922",
    "naicscode": "561599",
    "description": "Ticket Agencies - Theatrical - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "298",
    "classcode": "64141",
    "statcode": "64141",
    "siccode": "7999",
    "naicscode": "531120",
    "description": "Ticket Agencies - Other Than Theatrical -Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "299",
    "classcode": "64141",
    "statcode": "64141",
    "siccode": "7999",
    "naicscode": "561599",
    "description": "Ticket Agencies - Other Than Theatrical - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "300",
    "classcode": "64151",
    "statcode": "64151",
    "siccode": "7999",
    "naicscode": "531120",
    "description": "Ticket Agencies - Other Than Theatrical - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "301",
    "classcode": "64151",
    "statcode": "64151",
    "siccode": "7999",
    "naicscode": "561599",
    "description": "Ticket Agencies - Other Than Theatrical - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "302",
    "classcode": "64161",
    "statcode": "64161",
    "siccode": "6541",
    "naicscode": "531120",
    "description": "Title Agents - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "303",
    "classcode": "64161",
    "statcode": "64161",
    "siccode": "6541",
    "naicscode": "541191",
    "description": "Title Agents - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "304",
    "classcode": "64171",
    "statcode": "64171",
    "siccode": "6541",
    "naicscode": "531120",
    "description": "Title Agents - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "305",
    "classcode": "64171",
    "statcode": "64171",
    "siccode": "6541",
    "naicscode": "541191",
    "description": "Title Agents - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "306",
    "classcode": "64181",
    "statcode": "64181",
    "siccode": "740",
    "naicscode": "531120",
    "description": "Veterinarians Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "307",
    "classcode": "64181",
    "statcode": "64181",
    "siccode": "740",
    "naicscode": "541940",
    "description": "Veterinarians Office - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "308",
    "classcode": "64191",
    "statcode": "64191",
    "siccode": "0740",
    "naicscode": "531120",
    "description": "Veterinarians Office - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "309",
    "classcode": "64191",
    "statcode": "64191",
    "siccode": "740",
    "naicscode": "541940",
    "description": "Veterinarians Office - Condominium - Office",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "310",
    "classcode": "65111",
    "statcode": "65111",
    "siccode": "4941",
    "naicscode": "221310",
    "description": "Water Companies - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "311",
    "classcode": "65111",
    "statcode": "65111",
    "siccode": "4941",
    "naicscode": "531120",
    "description": "Water Companies - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "312",
    "classcode": "65161",
    "statcode": "65161",
    "siccode": "4941",
    "naicscode": "221310",
    "description": "Water Companies - Condominium - Office - Contact Underwriter for Special Acceptance",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "313",
    "classcode": "65161",
    "statcode": "65161",
    "siccode": "4941",
    "naicscode": "531120",
    "description": "Water Companies - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "314",
    "classcode": "65171",
    "statcode": "65171",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Not Classified - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "315",
    "classcode": "65171",
    "statcode": "65171",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Not Classified - Office - See list of acceptable NOC operations.  Contact underwriter for exceptions",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "316",
    "classcode": "65231",
    "statcode": "65231",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Not Classified - Condominium - Office - See list of acceptable NOC operations.  Contact underwriter for exceptions",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "317",
    "classcode": "65231",
    "statcode": "65231",
    "siccode": "6531",
    "naicscode": "531120",
    "description": "Not Otherwise Classified - Condominium - Office - Lessors Risk Only",
    "STATE_CODE": "MA",
    "propertytype": "Office (including Office & Commercial Condominiums).",
    "subclass": ""
   },
   {
    "id": "318",
    "classcode": "71212",
    "statcode": "71212",
    "siccode": "7620",
    "naicscode": "811412",
    "description": "Appliances and Accessories - installation, servicing or repair - Commercial or Household",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "319",
    "classcode": "71311",
    "statcode": "71311",
    "siccode": "5461",
    "naicscode": "311811",
    "description": "Bakeries - Retail - With baking on premises",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "320",
    "classcode": "71332",
    "statcode": "71332",
    "siccode": "7241",
    "naicscode": "812111",
    "description": "Barber Shops - Professional is available",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "321",
    "classcode": "71444",
    "statcode": "71444",
    "siccode": "8072",
    "naicscode": "339116",
    "description": "Dental Laboratories",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "322",
    "classcode": "71811",
    "statcode": "71811",
    "siccode": "7212",
    "naicscode": "812320",
    "description": "Laundry and Dry Cleaning or Dyeing Receiving Stations",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "323",
    "classcode": "71837",
    "statcode": "71837",
    "siccode": "7389",
    "naicscode": "488991",
    "description": "Mail Box or Packaging Stores - Packing and Preparing Goods For Shipping",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "324",
    "classcode": "71837",
    "statcode": "71837",
    "siccode": "7331",
    "naicscode": "511140",
    "description": "Mailing or Addressing Companies - Mailing List Compiling Services\/Mailing List Publishers",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "325",
    "classcode": "71837",
    "statcode": "71837",
    "siccode": "7331",
    "naicscode": "541860",
    "description": "Mailing or Addressing Companies - Direct Mailing Companies",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "326",
    "classcode": "71837",
    "statcode": "71837",
    "siccode": "7389",
    "naicscode": "561910",
    "description": "Mail Box or Packaging Stores - Packing and Preparing Goods For Shipping - Packaging Services (Except packing and crating for transportation)",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "327",
    "classcode": "71842",
    "statcode": "71842",
    "siccode": "3479",
    "naicscode": "332812",
    "description": "Engraving",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "328",
    "classcode": "71855",
    "statcode": "71855",
    "siccode": "2752",
    "naicscode": "323110",
    "description": "Lithographing",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "329",
    "classcode": "71865",
    "statcode": "71865",
    "siccode": "7261",
    "naicscode": "812210",
    "description": "Funeral Homes or Chapels - Professional is available",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "330",
    "classcode": "71877",
    "statcode": "71877",
    "siccode": "7334",
    "naicscode": "561438",
    "description": "Copying and Duplicating Stores",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "331",
    "classcode": "71888",
    "statcode": "71888",
    "siccode": "2796",
    "naicscode": "323122",
    "description": "Photoengraving",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "332",
    "classcode": "71899",
    "statcode": "71899",
    "siccode": "7221",
    "naicscode": "711510",
    "description": "Photographers",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "333",
    "classcode": "71912",
    "statcode": "71912",
    "siccode": "2700",
    "naicscode": "32311",
    "description": "Printing",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "334",
    "classcode": "71921",
    "statcode": "71921",
    "siccode": "7622",
    "naicscode": "811211",
    "description": "Television or Radio Receiving Set Installation or Repair",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "335",
    "classcode": "71926",
    "statcode": "71926",
    "siccode": "7251",
    "naicscode": "811430",
    "description": "Shoe Stores - Repair",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "336",
    "classcode": "71941",
    "statcode": "71941",
    "siccode": "7631",
    "naicscode": "811490",
    "description": "Jewelry - Retail - MAPFRE is a market for building and furnishings but not stock.",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "337",
    "classcode": "71952",
    "statcode": "71952",
    "siccode": "7231",
    "naicscode": "812112",
    "description": "Beauty Parlors and Hair Styling Salons (Including Nail Salons) - Professional is available.  Also includes Spas",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "338",
    "classcode": "71952",
    "statcode": "71952",
    "siccode": "7231",
    "naicscode": "812113",
    "description": "Nail Salons - Professional is available",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "339",
    "classcode": "71961",
    "statcode": "71961",
    "siccode": "5699",
    "naicscode": "811490",
    "description": "Tailoring or Dressmaking Establishments - Custom",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "340",
    "classcode": "71976",
    "statcode": "71976",
    "siccode": "7699",
    "naicscode": "711510",
    "description": "Taxidermists",
    "STATE_CODE": "MA",
    "propertytype": "Processing and Service Risks",
    "subclass": ""
   },
   {
    "id": "341",
    "classcode": "09001",
    "statcode": "09001",
    "siccode": "5812",
    "naicscode": "722212",
    "description": "Fast Food Restaurants - Cafes - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "342",
    "classcode": "09011",
    "statcode": "09011",
    "siccode": "5812",
    "naicscode": "722212",
    "description": "Limited Cooking Restaurants - Cafes - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "343",
    "classcode": "09021",
    "statcode": "09021",
    "siccode": "5812",
    "naicscode": "722212",
    "description": "Fast Food Restaurants - Cafeteria Style - Buffet - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "344",
    "classcode": "09031",
    "statcode": "09031",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Chicken - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "345",
    "classcode": "09041",
    "statcode": "09041",
    "siccode": "5812",
    "naicscode": "722213",
    "description": "Limited Cooking Restaurants - Coffee Bars or Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "346",
    "classcode": "09051",
    "statcode": "09051",
    "siccode": "5812",
    "naicscode": "722213",
    "description": "Fast Food Restaurants - Concession Stands\/Snack Bars - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "347",
    "classcode": "09061",
    "statcode": "09061",
    "siccode": "5812",
    "naicscode": "722213",
    "description": "Limited Cooking Restaurants - Concession Stands\/Snack Bars - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "348",
    "classcode": "09071",
    "statcode": "09071",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Delicatessens and Sandwich Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "349",
    "classcode": "09081",
    "statcode": "09081",
    "siccode": "5812",
    "naicscode": "445210",
    "description": "Limited Cooking Restaurants - Delicatessens and Sandwich Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "350",
    "classcode": "09091",
    "statcode": "09091",
    "siccode": "5812",
    "naicscode": "722210",
    "description": "Fast Food Restaurants - Donut Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "351",
    "classcode": "09101",
    "statcode": "09101",
    "siccode": "5812",
    "naicscode": "722210",
    "description": "Limited Cooking Restaurants - Donut Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "352",
    "classcode": "09111",
    "statcode": "09111",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Drive-ins\/Service in Car (When Drive-ins\/Service in Car and any other eligible classification applies, rate and code the restaurant as Drive-ins\/Service in Car.) - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "353",
    "classcode": "09121",
    "statcode": "09121",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Limited Cooking Restaurants - Drive-ins\/Service in Car (When Drive-ins\/Service in Car and any other eligible restaurant classification applies, rate and code the restaurant as Drive-ins\/Service in Car.) - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "354",
    "classcode": "09131",
    "statcode": "09131",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Drug Stores - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "355",
    "classcode": "09141",
    "statcode": "09141",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Limited Cooking Restaurants - Drug Stores - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "356",
    "classcode": "09151",
    "statcode": "09151",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Hamburger\/Malt Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "357",
    "classcode": "09161",
    "statcode": "09161",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Hotdog Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "358",
    "classcode": "09171",
    "statcode": "09171",
    "siccode": "5812",
    "naicscode": "722213",
    "description": "Limited Cooking Restaurants - Ice Cream and Yogurt Stores - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "359",
    "classcode": "09181",
    "statcode": "09181",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Oriental Style - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "360",
    "classcode": "09191",
    "statcode": "09191",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Other Ethnic Style - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "361",
    "classcode": "09201",
    "statcode": "09201",
    "siccode": "5812",
    "naicscode": "722210",
    "description": "Fast Food Restaurants - Pizza Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "362",
    "classcode": "09211",
    "statcode": "09211",
    "siccode": "5812",
    "naicscode": "722210",
    "description": "Limited Cooking Restaurants - Pizza Shops - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "363",
    "classcode": "09221",
    "statcode": "09221",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Roast Beef - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "364",
    "classcode": "09231",
    "statcode": "09231",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Limited Cooking Restaurants - Salad Bars - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "365",
    "classcode": "09241",
    "statcode": "09241",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Seafood - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "366",
    "classcode": "09251",
    "statcode": "09271",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Fast Food Restaurants - Take Out Only Restaurants - No on-premises consumption of food (When Take Out Only Restaurants - No on-premises consumption of food and any other eligible restaurant classification applies, rate and code the restaurant as Take Out Only Restaurants - No on-premises consumption of food.) - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "367",
    "classcode": "09261",
    "statcode": "09261",
    "siccode": "5812",
    "naicscode": "722211",
    "description": "Limited Cooking Restaurants - Take Out Only Restaurants - No on-premises consumption of food (When Take Out Only Restaurants - No on-premises consumption of food and any other eligible restaurant classification applies, rate and code the restaurant as Take Out Only Restaurants - No on-premises consumption of food.) - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "368",
    "classcode": "09421",
    "statcode": "09421",
    "siccode": "5812",
    "naicscode": "72212",
    "description": "Fine Dining - With no sales of alcoholic beverages",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "369",
    "classcode": "09431",
    "statcode": "09431",
    "siccode": "5812",
    "naicscode": "72212",
    "description": "Fine Dining - With sales of alcoholic beverages up to 30% of total sales",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "370",
    "classcode": "09441",
    "statcode": "09441",
    "siccode": "5812",
    "naicscode": "72212",
    "description": "Fine Dining - With sales of alcoholic beverages more than 30% up to 75% of total sales",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "371",
    "classcode": "09451",
    "statcode": "09451",
    "siccode": "5812",
    "naicscode": "72212",
    "description": "Fine Dining - Bring Your Own Alcohol Establishments - With no sales of alcoholic beverages",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "372",
    "classcode": "09611",
    "statcode": "09611",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Bistros, Brasseries and Cafes - With no sales of alcoholic beverages - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "373",
    "classcode": "09621",
    "statcode": "09621",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Bistros, Brasseries and Cafes - With sales of alcoholic beverages up to 50% of total sales - MAPFRE further limits liquor to 30% or less. See Restaurant Supplement and Questionnaire.",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "374",
    "classcode": "09631",
    "statcode": "09631",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Diners - With no sales of alcoholic beverages - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "375",
    "classcode": "09641",
    "statcode": "09641",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Diners - With sales of alcoholic beverages up to 50% of total sales - MAPFRE further limits liquor to 30% or less.  See Restaurant Supplement and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "376",
    "classcode": "09651",
    "statcode": "09651",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Family-style Restaurants - With no sales of alcoholic beverages - See Restaurant Guideline and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "377",
    "classcode": "09661",
    "statcode": "09661",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Family-style Restaurants - With sales of alcoholic beverages up to 50% of total sales - MAPFRE further limits liquor to 30% or less.  See Restaurant Supplement and Questionnaire",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "378",
    "classcode": "09671",
    "statcode": "09671",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Bistros, Brasseries and Cafes - Bring Your Own Alcohol Establishments - With no sales of alcoholic beverages",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "379",
    "classcode": "09681",
    "statcode": "09681",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Diners - Bring Your Own Alcohol Establishments - With no sales of alcoholic beverages",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "380",
    "classcode": "09691",
    "statcode": "09691",
    "siccode": "5812",
    "naicscode": "72210",
    "description": "Casual Dining - Family-style Restaurants - Bring Your Own Alcohol Establishments - With no sales of alcoholic beverages",
    "STATE_CODE": "MA",
    "propertytype": "Restaurants",
    "subclass": ""
   },
   {
    "id": "381",
    "classcode": "09411",
    "statcode": "09411",
    "siccode": "4225",
    "naicscode": "531130",
    "description": "Self-storage Facilities",
    "STATE_CODE": "MA",
    "propertytype": "Self-Storage Facilities",
    "subclass": ""
   },
   {
    "id": "382",
    "classcode": "50061",
    "statcode": "50061",
    "siccode": "5064",
    "naicscode": "421620",
    "description": "Appliance Distributors - Household Types - Radio, Television or Compact Disc Players",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "383",
    "classcode": "50081",
    "statcode": "50081",
    "siccode": "5064",
    "naicscode": "421620",
    "description": "Appliance Distributors - Household and Home Furnishings",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "384",
    "classcode": "50111",
    "statcode": "50111",
    "siccode": "5013",
    "naicscode": "421120",
    "description": "Automobile Parts and Supplies - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "385",
    "classcode": "50141",
    "statcode": "50141",
    "siccode": "5149",
    "naicscode": "422490",
    "description": "Bakeries - Distributors - No baking on premises",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "386",
    "classcode": "50171",
    "statcode": "50171",
    "siccode": "5087",
    "naicscode": "421850",
    "description": "Barber or Beauty Shop Supplies Distributors (No re-packaging or re-labeling for \"own brand\" retail sale",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "387",
    "classcode": "50201",
    "statcode": "50201",
    "siccode": "5085",
    "naicscode": "32311",
    "description": "Bookbinding and Printing Supplies - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "388",
    "classcode": "50231",
    "statcode": "50231",
    "siccode": "5136",
    "naicscode": "422320",
    "description": "Clothing or Wearing Apparel - Distributors - Men's and Boy's Clothing and Furnishings",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "389",
    "classcode": "50231",
    "statcode": "50231",
    "siccode": "5137",
    "naicscode": "422330",
    "description": "Clothing or Wearing Apparel - Distributors - Women's, Children's and Infants' Clothing and Accessories",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "390",
    "classcode": "50261",
    "statcode": "50261",
    "siccode": "5092",
    "naicscode": "421920",
    "description": "Collectibles and Memorabilia - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "391",
    "classcode": "50321",
    "statcode": "50321",
    "siccode": "5131",
    "naicscode": "422310",
    "description": "Fabric - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "392",
    "classcode": "50351",
    "statcode": "50351",
    "siccode": "5023",
    "naicscode": "421220",
    "description": "Floor Covering - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "393",
    "classcode": "50381",
    "statcode": "50381",
    "siccode": "5193",
    "naicscode": "422930",
    "description": "Florists - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "394",
    "classcode": "50391",
    "statcode": "50391",
    "siccode": "5148",
    "naicscode": "422480",
    "description": "Fruit or Vegetable -Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "395",
    "classcode": "50471",
    "statcode": "50471",
    "siccode": "5191",
    "naicscode": "422910",
    "description": "Gardening and Light Farming Supply - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "396",
    "classcode": "50481",
    "statcode": "50481",
    "siccode": "5141",
    "naicscode": "422410",
    "description": "Grocery - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "397",
    "classcode": "50501",
    "statcode": "50501",
    "siccode": "5072",
    "naicscode": "421710",
    "description": "Hardware and Tools - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "398",
    "classcode": "50571",
    "statcode": "50571",
    "siccode": "5047",
    "naicscode": "421450",
    "description": "Hearing Aid - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "399",
    "classcode": "50581",
    "statcode": "50581",
    "siccode": "5074",
    "naicscode": "421730",
    "description": "Heating or Combined Heating and Air Conditioning equipment - Distributors Only",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "400",
    "classcode": "50581",
    "statcode": "50581",
    "siccode": "5075",
    "naicscode": "421730",
    "description": "Air Conditioning and Combined Air Conditioning and Heating Equipment - Distributors Only",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "401",
    "classcode": "50641",
    "statcode": "50641",
    "siccode": "5092",
    "naicscode": "421920",
    "description": "Hobby, Craft or Artists' Supply - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "402",
    "classcode": "50671",
    "statcode": "50671",
    "siccode": "5144",
    "naicscode": "422440",
    "description": "Meat, Fish, Poultry or Seafood - Distributors - Poultry",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "403",
    "classcode": "50671",
    "statcode": "50671",
    "siccode": "5146",
    "naicscode": "422460",
    "description": "Meat, Fish, Poultry or Seafood - Distributors - Fish or Seafood",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "404",
    "classcode": "50671",
    "statcode": "50671",
    "siccode": "5147",
    "naicscode": "422470",
    "description": "Meat, Fish, Poultry or Seafood - Distributors - Meat",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "405",
    "classcode": "50691",
    "statcode": "50691",
    "siccode": "5044",
    "naicscode": "421420",
    "description": "Office Machines or Appliances - Distributors - No Repair",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "406",
    "classcode": "50721",
    "statcode": "50721",
    "siccode": "5048",
    "naicscode": "421460",
    "description": "Optical Goods - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "407",
    "classcode": "50741",
    "statcode": "50741",
    "siccode": "5074",
    "naicscode": "421720",
    "description": "Plumbing Supplies and Fixtures - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "408",
    "classcode": "50771",
    "statcode": "50771",
    "siccode": "5078",
    "naicscode": "421740",
    "description": "Refrigeration Equipment - Commercial - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "409",
    "classcode": "50801",
    "statcode": "50801",
    "siccode": "5110",
    "naicscode": "422110",
    "description": "Stationery or Paper Products Distributors - Paper (e.g., fine, printing, writing), bulk, wholesaling",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "410",
    "classcode": "50801",
    "statcode": "50801",
    "siccode": "5110",
    "naicscode": "422130",
    "description": "Stationery or Paper Products Distributors - Paper (except office supplies, printing paper, stationery, writing paper) wholesaling",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   },
   {
    "id": "411",
    "classcode": "50901",
    "statcode": "50901",
    "siccode": "5092",
    "naicscode": "421920",
    "description": "Toys - Distributors",
    "STATE_CODE": "MA",
    "propertytype": "Wholesale Risks",
    "subclass": ""
   }
  ]